import { MembershipReferralsPage } from './membership-referrals.page';
import { useMembershipReferrals } from './use-membership-referrals.hook';

type MembershipReferralsControllerProps = {
  membershipId: string;
};

export const MembershipReferralsController = (props: MembershipReferralsControllerProps) => {
  const { membershipId } = props;
  const {
    totalReferrals,
    referralCode,
    referrals,
    paginationProps,
    isReferralsLoading,
    isReferralInfoLoading,
    search,
    error,
  } = useMembershipReferrals({
    membershipId,
  });

  return (
    <MembershipReferralsPage
      totalReferrals={totalReferrals}
      referralCode={referralCode}
      referrals={referrals}
      isReferralsLoading={isReferralsLoading}
      isReferralInfoLoading={isReferralInfoLoading}
      paginationProps={paginationProps}
      search={search}
      error={error}
    />
  );
};
